module.exports = __webpack_public_path__ + "img/group2.b82b8527.png";